<template>
  <div class="sub-customer">
    <top :username="username"></top>
    <leftMenu></leftMenu>
    <div class="data-govern-body">
      <breadcrumbTrail :trail="'子账户管理 > 分配余额'"></breadcrumbTrail>
      <div class="body">
        <ul>
          <li class="li-item">
            <span class="li-item-key">可分配余额：</span>
            <span class="li-item-val balance-num">￥{{ AllotAmount }}</span>
          </li>
          <li class="li-item">
            <span class="li-item-key">选择子账户：</span>
            <span class="li-item-val">
              <el-select class="w262" @change="changeSubFirm" v-model="subFirmId" placeholder="请选择">
                <el-option
                  v-for="item in subUserList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </span>
          </li>
          <span class="error-tip sub-account" v-if="status.subAccount">*选择子账户不可为空</span>
          <li class="li-item">
            <span class="li-item-key">子账户余额：</span>
            <span class="li-item-val balance-num">{{ subUserInfo.AdsBalance }}</span>
          </li>
          <li class="li-item">
            <span class="li-item-key">子账户公司名称：</span>
            <span class="li-item-val">{{ subUserInfo.CompayName }}</span>
          </li>
          <li class="li-item">
            <span class="li-item-key">子账户姓名：</span>
            <span class="li-item-val">{{ subUserInfo.UserName }}</span>
          </li>
          <li class="li-item">
            <span class="li-item-key">电话号码：</span>
            <span class="li-item-val">{{ subUserInfo.TelePhone }}</span>
          </li>
          <li class="li-item">
            <span class="li-item-key">子账户邮箱：</span>
            <span class="li-item-val">{{ subUserInfo.UserEmail }}</span>
          </li>
          <li class="li-item input-item">
            <span class="li-item-key">充值金额：</span>
            <span class="li-item-val">
              <el-input
                placeholder="请输入充值金额"
                type="number"
                class="input w262"
                clearable v-model="allotAmountData.amount"
                @focus="status.toggleError=false"></el-input>
            </span>
          </li>
          <span class="error-tip" v-if="status.toggleError">*{{status.errorInfo}}</span>
          <li class="li-item input-item valid-code">
            <span class="li-item-key">验证码：</span>
            <span class="li-item-val">
              <el-input
                placeholder="请输入验证码"
                class="input w126"
                v-model="allotAmountData.VCode"
                clearable
                @focus="status.validCode=false"></el-input>
            </span>
            <img @click="randomNum" :src="vCodeSrc+ran" alt="">
          </li>
          <span class="error-tip" v-if="status.validCode">*{{status.vCodeInfo}}</span>
          <li class="btn-group">
            <el-button class="btn-item btn-cancel">取消</el-button>
            <el-button :class="['btn-item', 'btn-confirm', {'empty' : AllotAmount == 0}]" @click="saveAllotAmount">充值</el-button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import top from '../public/top.vue'
import leftMenu from '../public/left-menu.vue'
import breadcrumbTrail from '../public/Breadcrumb-Trail.vue'
import identify from '../public/identify'
import qs from 'qs'

export default {
  data () {
    return {
      vCodeSrc: 'http://test.customer.adxiaoguo.com/user/getvcode?a=',
      AllotAmount: 0,
      ran: 0,
      subFirmId: '',
      subUserList: [],
      subUserInfo: {},
      username: 'xiaoming',
      status: {
        toggleError: false,
        errorInfo: '充值金额不可出现小数点后三位',
        validCode: false,
        vCodeInfo: '验证码不可为空',
        subAccount: false
      },
      allotAmountData: {
        subUserId: 0,
        amount: '',
        VCode: ''
      },
      value: ''
    }
  },
  methods: {
    // 获取账户信息
    getAcountInfo () {
      this.$http.post(this.$root.urlPath.MJK + '/user/GetAcountInfo').then(result => {
        const res = result.data
        this.AllotAmount = res.AllotAmount.toFixed(2)
      })
    },
    // 切换子账户
    changeSubFirm () {
      this.getSubUserInfo(this.subFirmId)
      this.status.subAccount = false
      this.resetPageInfo()
    },
    // 获取用户信息
    getSubUserInfo (userId) {
      if (userId) {
        this.$http.post(this.$root.urlPath.MJK + '/user/GetSubUserInfo', qs.stringify({userId})).then(result => {
          const res = result.data
          this.subUserInfo = res.data
          this.subUserInfo.AdsBalance = this.subUserInfo.AdsBalance ? '￥' + this.subUserInfo.AdsBalance : '----'
          this.subUserInfo.CompayName = this.subUserInfo.CompayName ? this.subUserInfo.CompayName : '----'
          this.subUserInfo.UserName = this.subUserInfo.UserName ? this.subUserInfo.UserName : '----'
          this.subUserInfo.UserEmail = this.subUserInfo.UserEmail ? this.subUserInfo.UserEmail : '----'
          this.subUserInfo.TelePhone = this.subUserInfo.TelePhone ? this.subUserInfo.TelePhone : '----'
          this.subUserInfo.AdsBalance = this.subUserInfo.AdsBalance ? this.subUserInfo.AdsBalance : '----'
        })
      } else {
        setTimeout(() => {
          this.subUserInfo = {
            CompayName: '----',
            UserName: '----',
            UserEmail: '----',
            TelePhone: '----',
            AdsBalance: '----'
          }
        }, 500)
      }
    },
    // 获取子账户列表信息
    GetSubUserList () {
      this.$http.post(this.$root.urlPath.MJK + '/user/GetSubUserList').then(result => {
        const res = result.data
        res.data.forEach((item, i) => {
          const subFirm = {
            value: item.UserId,
            label: item.CompayName
          }
          this.subUserList[i] = subFirm
        })
      })
    },
    // 生成随机数（刷新验证码）
    randomNum () {
      this.ran = Math.floor(Math.random()*1000)
    },
    // 保存分配金额
    saveAllotAmount () {
      this.allotAmountData.subUserId = this.subFirmId
      if (!this.allotAmountData.subUserId) {
        this.status.subAccount = true
      } else if (!this.allotAmountData.amount) {
        this.status.toggleError = true
        this.status.errorInfo = '充值金额不可为空'
      } else if (Number(this.allotAmountData.amount) - Number(this.allotAmountData.amount).toFixed(2) !== 0) {
        this.status.toggleError = true
        this.status.errorInfo = '充值金额不可出现小数点后三位'
        this.allotAmountData.amount = ''
      } else if (!this.allotAmountData.VCode) {
        this.status.validCode = true
        this.status.vCodeInfo = '验证码不可为空'
      } else {
        this.allotAmountData.amount = Number(this.allotAmountData.amount)
        this.$http.post(this.$root.urlPath.MJK + '/user/SaveAllotAmount', qs.stringify(this.allotAmountData)).then(result => {
          const res = result.data
          if (res.success) {
            this.$message({
              message: '充值成功',
              type: 'success'
            })
            this.getAcountInfo()
            this.resetPageInfo()
          } else {
            this.$message.error('充值失败')
            this.resetPageInfo()
            if (res.remark === '验证码错误') {
              this.status.validCode = true
              this.status.vCodeInfo = '验证码错误'
              this.allotAmountData.VCode = ''
            }
          }
        })
      }
    },
    // 充值页面信息
    resetPageInfo () {
      this.allotAmountData.amount = ''
      this.allotAmountData.VCode = ''
      this.randomNum()
    }
  },
  components: {
    top,
    leftMenu,
    breadcrumbTrail,
    identify
  },
  mounted () {
    this.getAcountInfo()
    this.getSubUserInfo(this.subFirmId)
    this.GetSubUserList()
    this.randomNum()
  }
}
</script>

<style lang="scss" scoped>
  @import '../../common/scss/color.scss';

  .data-govern-body {
    padding: 20px 30px 20px 20px;
    position: relative;
    .body {
      background-color: #fff;
      margin-top: 20px;
      box-shadow: 0 0 3px #e0e0e0;
      padding: 30px 22px;
      .li-item {
        line-height: 40px;
        height: 40px;
        display: flex;
        justify-content: flex-start;
        font-size: 16px;
        &.input-item {
          margin-top: 13px;
          &.valid-code {
            margin-top: 26px;
            .identifyCode-frame {
              margin-top: 1px;
              margin-left: 23px;
            }
            img {
              width: 120px;
              margin-left: 14px;
              height: 38px;
            }
          }
        }
        .li-item-key {
          width: 129px;
          text-align: right;
          color: #333;
        }
        .li-item-val {
          margin-left: 5px;
          color: #666;
          &.balance-num {
            color: $mainColor;
          }
        }
        .w262 {
          width: 262px;
        }
        .w126 {
          width: 126px;
        }
      }
      .btn-group {
        margin: 50px 23px;
        .btn-item, .btn-item:hover {
          width: 140px;
          height: 40px;
          line-height: 12px;
          border-radius: 20px;
          font-size: 16px;
          color: #333;
          border-color: #e0e0e0;
          background-color: #fff;
        }
        .btn-confirm, .btn-confirm:hover {
          border: none;
          color: #fff;
          background-color: $mainColor;
          box-shadow: 0 0 3px $mainColor;
        }
        .btn-confirm.empty {
          background-color: #ccc;
          box-shadow: 0 0 3px #ccc;
        }
      }
      .error-tip {
        color: red;
        font-size: 14px;
        margin-left: 138px;
        display: inline-block;
        margin-top: 10px;
        &.sub-account {
          padding-bottom: 17px;
        }
      }
    }
    .el-button--text {
      border: none;
      color: $mainColor;
      span {
        border-bottom: 1px solid $mainColor;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/branch/sub-cus-balance.vue